import AdminGuard from "helpers/AuthType/AdminGuard";
import React, { useState } from "react";
import { Form } from "react-router-dom";
import {
    Card,
    Col,
    Container,
    Row,
    CardBody,
    CardTitle,
    Label,
    Input,
    Button
} from "reactstrap";
import { addAgentApi } from "service/api";


const Addagents = () => {
    const [agent, setAgent] = useState({
        name: '',
        business_name: '',
        location: '',
        operating_since: '',
        properties_sale: '',
        properties_rent: '',
        close_deal: '',
        team_member: '',
        about: '',
        deals_in: '',
        operates_in: '',
        team_image: null
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setAgent(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleFileChange = (e) => {
        setAgent(prev => ({
            ...prev,
            team_image: e.target.files[0]
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append('name', agent.name);
        formData.append('business_name', agent.business_name);
        formData.append('location', agent.location);
        formData.append('operating_since', agent.operating_since);
        formData.append('properties_sale', agent.properties_sale);
        formData.append('properties_rent', agent.properties_rent);
        formData.append('close_deal', agent.close_deal);
        formData.append('team_member', agent.team_member);
        formData.append('about', agent.about);
        formData.append('deals_in', agent.deals_in);
        formData.append('operates_in', agent.operates_in);

        if (agent.team_image) {
            formData.append('team_image', agent.team_image);
        }

        try {
            const res = await addAgentApi(formData); // Call the API method
            console.log("Agent added:", res.data);

            // Reset form
            setAgent({
                name: '',
                business_name: '',
                location: '',
                operating_since: '',
                properties_sale: '',
                properties_rent: '',
                close_deal: '',
                team_member: '',
                about: '',
                deals_in: '',
                operates_in: '',
                team_image: null
            });
        } catch (error) {
            console.error("Error adding agent:", error);
        }
    };
    return (
        <AdminGuard>
            <div className="page-content" style={{ color: "#fff", fontFamily: "'Roboto', sans-serif" }}>
                <Container fluid={true} className="py-1">
                    <Row className="justify-content-center">
                        <Col xl={12} lg={12} md={12}>
                            <Card style={{ backgroundColor: '#1E253A' }}>
                                <CardBody>
                                    <CardTitle className="h3">Add Agent</CardTitle>
                                    <form onSubmit={handleSubmit}>
                                        <Row>
                                            {/* First Column */}
                                            <Col md="3">
                                                <div className="mb-3">
                                                    <Label htmlFor="name">Agent Name</Label>
                                                    <Input
                                                        type="text"
                                                        className="form-control"
                                                        id="name"
                                                        name="name"
                                                        value={agent.name}
                                                        onChange={handleChange}
                                                        style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}
                                                        required
                                                    />
                                                </div>

                                                <div className="mb-3">
                                                    <Label htmlFor="operating_since">Operating Since</Label>
                                                    <Input
                                                        type="text"
                                                        className="form-control"
                                                        id="operating_since"
                                                        name="operating_since"
                                                        value={agent.operating_since}
                                                        onChange={handleChange}
                                                        style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}
                                                    />
                                                </div>

                                                <div className="mb-3">
                                                    <Label htmlFor="close_deal">Close Deal</Label>
                                                    <Input
                                                        type="text"
                                                        className="form-control"
                                                        id="close_deal"
                                                        name="close_deal"
                                                        value={agent.close_deal}
                                                        onChange={handleChange}
                                                        style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}
                                                    />
                                                </div>
                                            </Col>

                                            {/* Second Column */}
                                            <Col md="3">
                                                <div className="mb-3">
                                                    <Label htmlFor="business_name">Business Name</Label>
                                                    <Input
                                                        type="text"
                                                        className="form-control"
                                                        id="business_name"
                                                        name="business_name"
                                                        value={agent.business_name}
                                                        onChange={handleChange}
                                                        style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}
                                                    />
                                                </div>

                                                <div className="mb-3">
                                                    <Label htmlFor="properties_sale">Properties for Sale</Label>
                                                    <Input
                                                        type="text"
                                                        className="form-control"
                                                        id="properties_sale"
                                                        name="properties_sale"
                                                        value={agent.properties_sale}
                                                        onChange={handleChange}
                                                        style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}
                                                    />
                                                </div>

                                                <div className="mb-3">
                                                    <Label htmlFor="team_member">Team Member</Label>
                                                    <Input
                                                        type="text"
                                                        className="form-control"
                                                        id="team_member"
                                                        name="team_member"
                                                        value={agent.team_member}
                                                        onChange={handleChange}
                                                        style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}
                                                    />
                                                </div>
                                            </Col>

                                            {/* Third Column */}
                                            <Col md="3">
                                                <div className="mb-3">
                                                    <Label htmlFor="location">Location</Label>
                                                    <Input
                                                        type="text"
                                                        className="form-control"
                                                        id="location"
                                                        name="location"
                                                        value={agent.location}
                                                        onChange={handleChange}
                                                        style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}
                                                    />
                                                </div>

                                                <div className="mb-3">
                                                    <Label htmlFor="properties_rent">Properties for Rent</Label>
                                                    <Input
                                                        type="text"
                                                        className="form-control"
                                                        id="properties_rent"
                                                        name="properties_rent"
                                                        value={agent.properties_rent}
                                                        onChange={handleChange}
                                                        style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}
                                                    />
                                                </div>

                                                <div className="mb-3">
                                                    <Label htmlFor="deals_in">Deals In</Label>
                                                    <Input
                                                        type="text"
                                                        className="form-control"
                                                        id="deals_in"
                                                        name="deals_in"
                                                        value={agent.deals_in}
                                                        onChange={handleChange}
                                                        style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}
                                                    />
                                                </div>
                                            </Col>

                                            {/* Fourth Column */}
                                            <Col md="3">
                                                <div className="mb-3">
                                                    <Label htmlFor="about">About</Label>
                                                    <Input
                                                        type="textarea"
                                                        className="form-control"
                                                        id="about"
                                                        name="about"
                                                        value={agent.about}
                                                        onChange={handleChange}
                                                        style={{
                                                            backgroundColor: "rgba(255, 255, 255, 0.2)",
                                                            color: "#fff",
                                                            minHeight: "100px"
                                                        }}
                                                    />
                                                </div>

                                                <div className="mb-3">
                                                    <Label htmlFor="operates_in">Operates In</Label>
                                                    <Input
                                                        type="text"
                                                        className="form-control"
                                                        id="operates_in"
                                                        name="operates_in"
                                                        value={agent.operates_in}
                                                        onChange={handleChange}
                                                        style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}
                                                    />
                                                </div>

                                                <div className="mb-3">
                                                    <Label htmlFor="team_image">Team Image</Label>
                                                    <Input
                                                        type="file"
                                                        className="form-control"
                                                        id="team_image"
                                                        name="team_image"
                                                        onChange={handleFileChange}
                                                        style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", color: "#fff" }}
                                                    />
                                                </div>
                                            </Col>

                                            {/* Submit Button - Full Width */}
                                            <Col md="3" style={{ marginLeft: "75%" }}>
                                                <div
                                                >
                                                    <Button
                                                        type="submit"
                                                        style={{
                                                            width: "100%",
                                                            fontWeight: "600",
                                                            background: "linear-gradient(to right, #6a11cb, #2575fc)",
                                                            border: "none",
                                                            padding: "10px 20px",
                                                            borderRadius: "25px",
                                                        }}
                                                    >
                                                        Save Agent
                                                    </Button>
                                                </div>
                                            </Col>

                                        </Row>
                                    </form>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </AdminGuard>
    );
};

export default Addagents;